const carouselItems = [
  {
    id: 1,
    title: '娱乐圈年度大事件回顾：从塌房到逆袭',
    excerpt: '盘点过去一年娱乐圈最令人震惊的十大事件，从顶流塌房到黑马逆袭，每一件都足以写入娱乐史册。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20spotlight%20stage%20with%20dark%20background%2C%20golden%20amber%20lightbeams%2C%20entertainment%20award%20show%20atmosphere%2C%20cinematic%20composition%2C%20no%20people%2C%20no%20text&width=1200&height=600&seq=carousel-1-51hl&orientation=landscape',
    tag: '年度盘点',
  },
  {
    id: 2,
    title: '某综艺节目争议片段全网下架始末',
    excerpt: '一档热门综艺因播出内容引发巨大争议，节目组紧急下架相关片段但仍难平众怒。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20controversial%20TV%20show%20drama%20visual%20with%20split%20screen%20effect%2C%20dark%20atmosphere%20with%20warm%20tension%20lighting%2C%20media%20controversy%2C%20no%20people%2C%20no%20text&width=1200&height=600&seq=carousel-2-51hl&orientation=landscape',
    tag: '深度追踪',
  },
  {
    id: 3,
    title: '短视频时代网红生态大洗牌',
    excerpt: '从内容创作者到MCN机构，整个网红产业链正经历前所未有的大变革。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20content%20creator%20ecosystem%20visual%20with%20network%20connections%2C%20dark%20tech%20background%20with%20warm%20glowing%20nodes%2C%20modern%20social%20media%20aesthetic%2C%20no%20people%2C%20no%20text&width=1200&height=600&seq=carousel-3-51hl&orientation=landscape',
    tag: '行业观察',
  },
  {
    id: 4,
    title: '某顶流演唱会假唱风波技术分析',
    excerpt: '专业音乐人逐帧分析某知名歌手演唱会疑似假唱的技术证据，引发圈内热议。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20concert%20stage%20with%20dramatic%20spotlights%2C%20dark%20audience%20silhouettes%2C%20music%20performance%20atmosphere%2C%20golden%20amber%20beams%2C%20mysterious%20tension%2C%20no%20people%2C%20no%20text&width=1200&height=600&seq=carousel-4-51hl&orientation=landscape',
    tag: '技术吃瓜',
  },
  {
    id: 5,
    title: '某品牌危机公关：从全网抵制到口碑逆转',
    excerpt: '一个经典品牌公关案例深度剖析，看危机中的品牌如何一步步赢回消费者信任。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20brand%20reputation%20recovery%20visual%20with%20rising%20graph%20and%20warm%20hopeful%20lighting%2C%20dark%20to%20bright%20transition%2C%20corporate%20comeback%20aesthetic%2C%20no%20people%2C%20no%20text&width=1200&height=600&seq=carousel-5-51hl&orientation=landscape',
    tag: '公关复盘',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            深度追踪最受关注的娱乐事件与吃瓜热点
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden flex flex-col sm:flex-row transition-all hover:-translate-y-0.5 cursor-pointer"
            >
              <div className="sm:w-[280px] lg:w-[340px] flex-shrink-0 aspect-[16/10] sm:aspect-auto sm:h-auto bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 sm:p-6 flex flex-col justify-center">
                <span className="text-xs bg-accent-100 text-accent-800 px-2 py-0.5 rounded-md font-medium self-start mb-3">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}